import { useQuery } from '@tanstack/react-query';
import { getTicketLifecycle } from '../requests/ticketLifecycle.request';
import toast from 'react-hot-toast';

export const useTicketLifecycleQuery = (ticketId: string | undefined) => {
  return useQuery({
    queryKey: ['ticket-lifecycle', ticketId],
    queryFn: async () => {
      if (!ticketId) throw new Error('No ticket ID provided');
      return await getTicketLifecycle(ticketId);
    },
    enabled: !!ticketId,
    onError: () => {
      toast.error("Couldn't fetch ticket lifecycle data", { id: 'ticket-lifecycle-error' });
    }
  });
};
